// クリップのゴミ箱復元（確認ダイアログのみ、フォルダ選択機能は無い）
export const useClipTrashRestore = () => {
  const confirmClipTrashRestoreSubmit = (event, message) => {
    if (!window.confirm(message)) {
      event.preventDefault();
    }
  };

  return { confirmClipTrashRestoreSubmit };
};
